import comm_data from './../comm_data';
import apiFormData from './apiFormData';
import api from './api';


export default class ApiGo_ProdKey {

    /**
     * POST/後端prodkey 
     *     
     * @param {FormData} _data: 上傳bin檔案
     */
    static rsaDecrypt(_data) {
        const apiParas = {
            type: 'rsa_decrypt',
        };

        const form_data = _data;

        return apiFormData({
            url: `${comm_data.API_PROD_KEY_HOST}/${apiParas.type}`,
            method: 'POST', //請求方法
            form_data: form_data,
            type: apiParas.type
        })
    }

    /**
     * GET/JS 文本建立
     */
    static generateJSConfig(_data) {
        const apiParas = {
            type: 'generate_js_config',
        };

        return apiFormData({
            url: `${comm_data.API_PROD_KEY_HOST}/${apiParas.type}`,
            method: 'GET', //請求方法
            // form_data: form_data,
            type: apiParas.type
        })
    }

    /**
     * GET/取得 Local端(客戶端) 所有訂單資料
     */
    static getSerialKeys() {
        const apiParas = {
            type: 'get_serial_keys',
            // type: 'get_serial_keys1',
        };

        return api({
            url: `${comm_data.API_PROD_KEY_HOST}/${apiParas.type}`,
            method: 'GET', //請求方法
            // form_data: form_data,
            type: apiParas.type
        })
    }
    
    /**
     * GET/讀取系統UUID值
     *     
     * @param {FormData} _data: 上傳bin檔案
     */
    static getHwUUID(_data) {
        const apiParas = {
            type: 'get_hw_uuid',
        };

        return api({
            url: `${comm_data.API_PROD_KEY_HOST}/${apiParas.type}`,
            method: 'GET', //請求方法
            // form_data: form_data,
            type: apiParas.type
        })
    }

    
    /**
     * POST/新增經銷商資訊
     *     
     * @param {String} password - Dealer密碼
     * @param {String} tel - Dealer連絡電話
     * @param {String} email - Dealer信箱
     */
    static postDealerInfo({
        password,
        tel,
        email,
        // address,
    }) {
        const apiParas = {
            type: 'post_dealer_info',
        };

        const data = {
            password: password,
            tel: tel,
            email: email,
            // address: address,
        }

        return api({
            url: `${comm_data.API_PROD_KEY_HOST}/${apiParas.type}`,
            method: 'POST', //請求方法
            data: data,
            type: apiParas.type
        })
    }

    /**
     * GET/讀取經銷商資訊
     */
    static getDealerInfo(_data) {
        const apiParas = {
            type: 'get_dealer_info',
        };

        return api({
            url: `${comm_data.API_PROD_KEY_HOST}/${apiParas.type}`,
            method: 'GET', //請求方法
            // form_data: form_data,
            type: apiParas.type
        })
    }

}